module.exports = __webpack_public_path__ + "static/media/cuvrd.748f9b75.svg";